/** Platform */
/** Search platformm */
export const SEARCH_PLATFORM_REQUEST = 'SEARCH_PLATFORM_REQUEST';
export const SEARCH_PLATFORM_REQUEST_SUCCESS = 'SEARCH_PLATFORM_REQUEST_SUCCESS';
export const SEARCH_PLATFORM_REQUEST_FAILURE = 'SEARCH_PLATFORM_REQUEST_FAILURE';

export const SEARCH_PLATFORM_ADD = 'SEARCH_PLATFORM_ADD';
